import React, { FC } from 'react'
import { IconName } from '@fortawesome/fontawesome-common-types'

import { NotificationCard } from '../NotificationCard/NotificationCard'
import { useZonesList } from 'modulesCommon/serviceHooks'

import { NotificationSideMenuProps } from './NotificationSideMenu.props'

import styles from './NotificationSideMenu.module.scss'

export const NotificationSideMenu: FC<NotificationSideMenuProps> = ({ notifications, onClickNotification, onDeleteNotifications }) => {
  const { getZoneById } = useZonesList()

  return (
    <>
      {!notifications.length && <div className={styles.emptyData}>You're up to date!</div>}
      <div className={styles.list}>
        {notifications.map((item) => (
          <NotificationCard
            key={item.id}
            title={item.card.title}
            subtitle={item.card.subtitle}
            icon={item.card.icon as IconName}
            imagePath={item.card.imagePath}
            highlighted={item.card.highlighted}
            date={new Date(item.last_updated).toString()}
            zone={getZoneById(item.card.zoneId)}
            elementsMeta={item.card.count}
            onClear={onDeleteNotifications(item.ids)}
            onClickCard={onClickNotification(item)}
          />
        ))}
      </div>
    </>
  )
}
